module.exports = __webpack_public_path__ + "static/media/CONFETTIS.61837fba.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Element/img/CONFETTIS.png
// module id = 247
// module chunks = 0